module.exports = __webpack_public_path__ + "static/media/kraantje.efe18d1b.jpg";